import React from 'react';

import { string, bool, oneOf } from 'prop-types';
import { Link } from 'react-router-dom';

import BaseButton from 'components/Common/Buttons/ButtonV3/BaseButton';
import ShadowButton from 'components/Common/ShadowButtonV2';

import { isAbsoluteLink } from 'utils/urls';

import v from 'components/variables';

const colors = {
  red: v.redXtraDark,
  blue: v.blueXtraDark,
  gray: v.grayXtraDark,
};

const ButtonLink = ({
  href,
  disabled,
  color,
  newTab,
  isElementary,
  ...restProps
}) => {
  const selectedColor = disabled ? v.grayMedium : colors[color];
  const ButtonComponent = isElementary ? ShadowButton : BaseButton;

  const newTabProps =
    newTab || isAbsoluteLink(href)
      ? { target: '_blank', rel: 'noopener noreferrer' }
      : {};

  const linkProps = () => {
    if (disabled) {
      return {};
    }
    if (isAbsoluteLink(href)) {
      return { tagName: 'a', href, ...newTabProps };
    }
    return { tagName: Link, href, to: href, ...newTabProps };
  };

  return (
    <ButtonComponent
      {...restProps}
      {...linkProps()}
      selectedColor={selectedColor}
      color={isElementary ? color : undefined}
      disabled={disabled}
    />
  );
};

ButtonLink.propTypes = {
  href: string,
  disabled: bool,
  color: oneOf(['blue', 'red', 'gray']),
  newTab: bool,
  isElementary: bool,
};

ButtonLink.defaultProps = {
  href: '/',
  color: 'blue',
  disabled: false,
  newTab: false,
  isElementary: false,
};

export default ButtonLink;
